/* PZ quick view — shared component. Markup: snippets/pz-quick-view.liquid (one dialog per page); styles:
   assets/pz-quick-view.css; per-product facts: snippets/pz-quick-view-data.liquid (presentment prices,
   availability, shade descriptions, rating); media: /products/{handle}.js, fetched when the view opens (lazy).
   Built for the Holiday bundle page (Mobile rounds 2–3, Oct 2026); also opened from the blush "Compare all
   shades" popups (PDP + listicle LPs).

   Triggers: any element with data-pz-qv-open="{handle}" (+ optional data-pz-qv-variant="{id}"; otherwise the
   closest card's input[name=id]). data-pz-qv-stop on the trigger swallows the click so the host's own handlers
   (e.g. the compare popup's shade selection) do not fire. Focus returns to the trigger on close.

   Modes (PZQuickView.configure):
     'cart'   (default) the add button is a theme <product-form> submit → cart drawer / cart count / EG gift
              logic exactly like a product page add; the quick view closes when the cart drawer opens.
     'bundle' the host passes add(variant, qty, button, done) (holiday page: its own cart pipeline + toasts).
   Gallery: a shade's own media block (its featured media up to the next variant-attached image) then the
   product's generic media (before the first variant image). Video slides = the PDP's .pz-gv block, driven by
   pz-gallery-video.js (the track is a <media-gallery>): autoplay in view, pause off screen, pause/mute buttons. */
(function () {
  if (window.PZQuickView) return;

  var cfg = {
    mode: 'cart',
    add: null,
    money: null,          // price line
    buttonMoney: null,    // price inside the button
    labels: { add: 'Add', soldOut: 'Sold out', added: 'Added', select: 'Select shade' },
    maxQty: 9,
    addedMs: 1500,
    closeOnDrawer: true,
    onOpen: null,
    onClose: null,
    variantTitleFor: null, // function (trigger) → shade title to open (set slots: the slot's active swatch)
    tileOpens: null,      // function (trigger) → false = a [data-pz-qv-tile] click is left to the page (set slots)
    resolve: null,        // function (trigger) → { select: true } puts the view in SELECT SHADE mode
    select: null          // function (variant) — SELECT SHADE action (host closes what it needs to)
  };
  var root = null, els = {}, cache = {}, drawerWatched = false;
  var st = { open: false, handle: '', d: null, v: null, qty: 1, idx: 0, n: 0, trigger: null, lastFocus: null, source: null, swatchBg: {}, rating: '', loading: false, addedT: null, select: false };
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- scroll lock that keeps the page where it is ----------
     The theme scrolls <html> on desktop and <body> on mobile. Locking BOTH with overflow:hidden made body a scroll
     container and reset the html scroll to 0 (the "page jumps to the top" bug). So: find the element that is actually
     scrolling, lock only that one, and pin its scrollTop before and after (instantly — the theme uses smooth scrolling). */
  var lock = { el: null, top: 0 };
  function scroller() {
    var H = document.documentElement, B = document.body;
    if (B.scrollTop > 0) return B;
    if (H.scrollTop > 0) return H;
    var bo = getComputedStyle(B).overflowY;
    if ((bo === 'auto' || bo === 'scroll') && B.scrollHeight > B.clientHeight + 1 && H.scrollHeight <= H.clientHeight + 1) return B;
    return H;
  }
  function pin(el, top) {
    var prev = el.style.scrollBehavior; el.style.scrollBehavior = 'auto';
    el.scrollTop = top;
    if (el === document.documentElement && Math.abs(el.scrollTop - top) > 1) { try { window.scrollTo({ top: top, left: 0, behavior: 'instant' }); } catch (e) { window.scrollTo(0, top); } }
    el.style.scrollBehavior = prev;
  }
  /* Chrome re-evaluates the viewport scroller a frame after the root's overflow changes and can zero the position
     then — so the pin is repeated on the next frame and shortly after. */
  function pinSoon(el, top) {
    pin(el, top);
    requestAnimationFrame(function () { pin(el, top); setTimeout(function () { pin(el, top); }, 40); setTimeout(function () { pin(el, top); }, 160); });
  }
  function lockScroll() {
    if (lock.el) return;
    var el = scroller(); lock.el = el; lock.top = el.scrollTop;
    el.style.setProperty('overflow', 'hidden', 'important');
    pinSoon(el, lock.top);
  }
  function unlockScroll() {
    var el = lock.el; if (!el) return;
    lock.el = null;
    el.style.removeProperty('overflow');
    pinSoon(el, lock.top);
  }
  /* ---------- set-context defaults: a trigger inside a set / bundle slot (.product-bundle-item) on ANY template ----------
     SELECT SHADE instead of an add; selecting = the slot's own swatch click (what the old compare popup's tile did). */
  function slotOf(t) { return t && t.closest ? t.closest('.product-bundle-item') : null; }
  function defaultVariantTitleFor(t) { var li = slotOf(t), a = li && li.querySelector('.custom-swatches-variant-wrap.active[data-value]'); return a ? a.getAttribute('data-value') : null; }
  function defaultResolve(t) { return slotOf(t) ? { select: true } : null; }
  function defaultSelect(v, state) {
    var li = slotOf(state.trigger);
    var sw = li && li.querySelector('.custom-swatches-variant-wrap[data-value="' + String(v.title).replace(/"/g, '\\"') + '"]');
    var el = lock.el, top = lock.top;
    close('select');
    /* the slot's own handler runs in a fresh task and the scroll position is re-pinned after it (the theme's handler
       re-renders the slot and, when run inside the dialog's click, dropped the html scroll to 0) */
    setTimeout(function () {
      if (sw) sw.click(); else console.warn('[pz-qv] slot swatch not found', v.title);
      if (el) pinSoon(el, top);
    }, 0);
  }

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function q(sel, ctx) { return (ctx || root || document).querySelector(sel); }
  function qa(sel, ctx) { return Array.prototype.slice.call((ctx || root || document).querySelectorAll(sel)); }
  function defaultMoney(c) {
    var fmt = window.MinimogSettings && window.MinimogSettings.money_format;
    if (typeof window.formatMoney === 'function' && fmt) return window.formatMoney(c, fmt);
    return (c / 100).toFixed(2);
  }
  function money(c) { return (cfg.money || defaultMoney)(c); }
  function buttonMoney(c) { return (cfg.buttonMoney || cfg.money || defaultMoney)(c); }
  function upper(s) { return String(s).toUpperCase(); }
  function debounce(fn, ms) { var t; return function () { var a = arguments, c = this; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, ms); }; }
  function sized(url, w) { if (!url) return ''; return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'width=' + w; }

  /* ---------- data ---------- */
  function inlineData(handle) {
    var s = document.querySelector('script[data-pz-qv-pdata="' + handle + '"]');
    if (!s) return null;
    try { return JSON.parse(s.textContent); } catch (e) { console.warn('[pz-qv] data block', handle, e); return null; }
  }
  function rootUrl() { var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; return r.replace(/\/?$/, '/'); }
  function fetchProduct(handle) {
    if (cache[handle]) return cache[handle];
    cache[handle] = fetch(rootUrl() + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(normalise)
      .catch(function (err) { delete cache[handle]; throw err; });
    return cache[handle];
  }
  function bestMp4(sources) {
    var best = null;
    (sources || []).forEach(function (s) { if (s.format === 'mp4' && s.height <= 1080 && (!best || s.height > best.height)) best = s; });
    if (!best) (sources || []).forEach(function (s) { if (s.format === 'mp4' && !best) best = s; });
    return best ? best.url : '';
  }
  function normalise(p) {
    var attached = {};
    (p.variants || []).forEach(function (v) { if (v.featured_media && v.featured_media.id) attached[v.featured_media.id] = true; });
    var owner = 0, media = [];
    (p.media || []).forEach(function (m) {
      var isImg = m.media_type === 'image', isVid = m.media_type === 'video';
      if (!isImg && !isVid) return;
      var isAttached = isImg && !!attached[m.id];
      if (isAttached) owner = m.id;
      var src = isImg ? sized(m.src, 1200) : bestMp4(m.sources);
      if (!src) return;
      media.push({ id: m.id, type: isImg ? 'image' : 'video', src: src, poster: isVid ? sized((m.preview_image || {}).src, 1200) : '', alt: m.alt || p.title || '', variant: isAttached, block: owner });
    });
    return {
      handle: p.handle, title: p.title, media: media,
      variants: (p.variants || []).map(function (v) { return { id: v.id, title: v.title, price: v.price, available: !!v.available, media: v.featured_media ? v.featured_media.id : 0, desc: '' }; })
    };
  }
  function baseData(inline, handle) {
    var d = { handle: handle, title: '', expand: true, rating: '', desc: '', variants: [], media: null };
    if (inline) { d.title = inline.title || ''; d.expand = inline.expand !== false; d.rating = inline.rating || ''; d.desc = inline.desc || ''; d.variants = (inline.variants || []).map(function (v) { return { id: v.id, title: v.title, price: v.price, available: !!v.available, media: v.media || 0, desc: v.desc || '' }; }); }
    return d;
  }
  /* market-correct facts straight from the page when a card carries the theme's hidden variant select */
  function applySourceFacts(d, source) {
    if (!source || !source.querySelectorAll) return;
    qa('select.product-variant option[data-variant-title]', source).forEach(function (o) {
      var t = o.getAttribute('data-variant-title');
      d.variants.forEach(function (v) {
        if (v.title !== t) return;
        if (o.getAttribute('data-variant-price')) v.price = Number(o.getAttribute('data-variant-price'));
        if (o.getAttribute('data-variant-available')) v.available = o.getAttribute('data-variant-available') !== 'soldout';
        var ds = o.getAttribute('data-variant-short-description'); if (ds) v.desc = ds;
      });
    });
  }
  function galleryFor(d, v) {
    var usable = (d.media || []).filter(function (m) { return m.src; });
    var own = v && v.media ? usable.filter(function (m) { return m.block === v.media; }) : [];
    if (!own.length && v && v.media) own = usable.filter(function (m) { return m.id === v.media; });
    var generic = usable.filter(function (m) { return m.block === 0; });
    var list = own.concat(generic.filter(function (m) { return own.indexOf(m) < 0; }));
    return list.length ? list : usable;
  }
  function collectSwatches(source) {
    var map = {};
    if (!source || !source.querySelectorAll) return map;
    qa('.m-product-option--node__label[data-value]', source).forEach(function (l) {
      var cs = getComputedStyle(l), key = String(l.getAttribute('data-value') || '').toLowerCase();
      if (!map[key]) map[key] = { image: cs.backgroundImage, color: cs.backgroundColor };
    });
    return map;
  }
  function swatchStyle(title) {
    var bg = st.swatchBg[String(title).toLowerCase()];
    if (bg && bg.image && bg.image !== 'none') return 'background-image:' + bg.image + ';' + (bg.color ? 'background-color:' + bg.color + ';' : '');
    /* theme convention (assets/product-card-swatch.js): files/color_{handle}_50x.png */
    var handle = String(title).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    return 'background-image:url(//phasezeromakeup.com/cdn/shop/files/color_' + handle + '_50x.png);' + (bg && bg.color ? 'background-color:' + bg.color + ';' : '');
  }
  function findRating(source, d) {
    if (d && d.rating) return '<span class="pz-card-rating__star" aria-hidden="true">&#9733;</span> ' + esc(d.rating);
    var r = source && source.querySelector ? source.querySelector('.pz-card-rating') : null;
    if (r) return r.innerHTML;
    var attr = source && source.closest ? source.closest('[data-pz-qv-rating]') : null;
    if (attr && attr.getAttribute('data-pz-qv-rating')) return '<span class="pz-card-rating__star" aria-hidden="true">&#9733;</span> ' + esc(attr.getAttribute('data-pz-qv-rating'));
    return '';
  }
  function pickVariant(d, id, title) {
    var v = d.variants.filter(function (x) { return String(x.id) === String(id); })[0];
    if (!v && title) v = d.variants.filter(function (x) { return String(x.title).toLowerCase() === String(title).toLowerCase(); })[0];
    return v || d.variants[0] || null;
  }

  /* ---------- render ---------- */
  function title() { return st.d ? st.d.title + (st.d.expand && st.v ? ' - ' + st.v.title : '') : ''; }
  function ariaLabel() { return 'Quick view ' + (st.d ? st.d.title + (st.d.expand && st.v ? ' – ' + st.v.title : '') : ''); }
  function render() {
    var d = st.d, v = st.v; if (!d) return;
    root.setAttribute('aria-label', ariaLabel());
    els.title.textContent = title();
    els.rating.innerHTML = st.rating;
    els.price.textContent = v ? money(v.price) : '';
    els.desc.textContent = v ? (v.desc || d.desc || '') : (d.desc || '');
    var sh = '';
    if (d.expand && d.variants.length > 1) {
      d.variants.forEach(function (x) {
        sh += '<button type="button" class="pz-qv__swatch' + (x.available ? '' : ' pz-qv__swatch--soldout') + '" role="radio" aria-checked="' + (v && x.id === v.id) + '" aria-label="' + esc(x.title) + (x.available ? '' : ' (sold out)') + '" data-pz-qv-variant="' + x.id + '" style="' + esc(swatchStyle(x.title)) + '"></button>';
      });
    }
    els.swatches.innerHTML = sh;
    root.classList.toggle('pz-qv--soldout', !!v && !v.available);
    root.classList.toggle('pz-qv--select', !!st.select);
    updateBtn();
    buildGallery();
  }
  function updateBtn() {
    var btn = els.add, v = st.v; if (!btn) return;
    if (els.formId) els.formId.value = v ? v.id : '';
    if (els.formQty) els.formQty.value = st.qty;
    els.qty.textContent = st.qty;
    if (btn.classList.contains('is-added') || btn.classList.contains('m-spinner-loading') || (els.pf && els.pf.classList.contains('m-spinner-loading'))) return;
    var available = !!v && v.available;
    btn.disabled = !available; btn.classList.toggle('disabled', !available);
    if (els.selectBtn) { els.selectBtn.disabled = !available; els.selectBtn.classList.toggle('disabled', !available); els.selectBtn.querySelector('.btn').textContent = available ? cfg.labels.select : cfg.labels.soldOut; }
    qa('[data-pz-qv-step]').forEach(function (b) { b.disabled = !available; });
    if (!available) { els.label.textContent = cfg.labels.soldOut; els.btnPrice.textContent = ''; return; }
    els.label.textContent = cfg.labels.add;
    els.btnPrice.textContent = ' | ' + buttonMoney(v.price * st.qty);
  }
  function gvHTML(m) {
    return '<div class="pz-gv is-paused" style="--pz-gv-ar: 1;">' +
      '<video class="pz-gv__video" data-pz-gv muted loop playsinline preload="none" poster="' + esc(m.poster) + '" width="1000" height="1000" aria-label="' + esc(m.alt) + '"><source src="' + esc(m.src) + '" type="video/mp4"></video>' +
      '<img class="pz-gv__poster" src="' + esc(m.poster) + '" alt="" width="1000" height="1000" aria-hidden="true">' +
      '<div class="pz-gv__ctrls">' +
        '<button type="button" class="pz-gv__btn pz-gv__btn--play" aria-label="Play video">' +
          '<svg class="pz-gv__ico" viewBox="0 0 20 20" aria-hidden="true"><rect x="5" y="4" width="3.5" height="12" rx="0.5"></rect><rect x="11.5" y="4" width="3.5" height="12" rx="0.5"></rect></svg>' +
          '<svg class="pz-gv__ico pz-gv__ico--alt" viewBox="0 0 20 20" aria-hidden="true"><path d="M6.5 4.2v11.6L15.5 10z"></path></svg>' +
        '</button>' +
        '<button type="button" class="pz-gv__btn pz-gv__btn--mute" aria-label="Unmute video">' +
          '<svg class="pz-gv__ico" viewBox="0 0 20 20" aria-hidden="true"><path d="M3 7.5h3.2L10.5 4v12L6.2 12.5H3z"></path><path d="M13 7.2l4 5.6M17 7.2l-4 5.6" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"></path></svg>' +
          '<svg class="pz-gv__ico pz-gv__ico--alt" viewBox="0 0 20 20" aria-hidden="true"><path d="M3 7.5h3.2L10.5 4v12L6.2 12.5H3z"></path><path d="M13 7.3a3.6 3.6 0 0 1 0 5.4M15 5.3a6.4 6.4 0 0 1 0 9.4" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"></path></svg>' +
        '</button>' +
      '</div></div>';
  }
  function buildGallery() {
    if (!st.d.media) {
      els.track.innerHTML = '<div class="pz-qv__slide pz-qv__slide--loading" aria-busy="true"><svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3" opacity="0.25"></circle><path d="M22 12a10 10 0 0 0-10-10" stroke="currentColor" stroke-width="3" stroke-linecap="round"></path></svg></div>';
      els.dots.innerHTML = ''; st.n = 1; st.idx = 0; root.classList.add('pz-qv--single');
      return;
    }
    var list = galleryFor(st.d, st.v), h = '', dh = '';
    list.forEach(function (m, i) {
      if (m.type === 'video') h += '<div class="pz-qv__slide" data-i="' + i + '">' + gvHTML(m) + '</div>';
      else h += '<div class="pz-qv__slide" data-i="' + i + '"><img src="' + esc(m.src) + '" alt="' + esc(m.alt) + '" width="1200" height="1200"' + (i === 0 ? ' decoding="async"' : ' loading="lazy" decoding="async"') + '></div>';
      dh += '<button type="button" class="swiper-pagination-bullet' + (i === 0 ? ' swiper-pagination-bullet-active' : '') + '" role="tab" aria-selected="' + (i === 0) + '" aria-label="' + (i + 1) + ' of ' + list.length + '" data-pz-qv-go="' + i + '"></button>';
    });
    els.track.innerHTML = h; els.dots.innerHTML = dh;
    st.n = list.length; st.idx = 0;
    root.classList.toggle('pz-qv--single', list.length < 2);
    els.track.scrollLeft = 0;
    sync();
  }
  function sync() {
    var w = els.track.clientWidth || 1;
    st.idx = Math.max(0, Math.min(st.n - 1, Math.round(els.track.scrollLeft / w)));
    qa('.swiper-pagination-bullet', els.dots).forEach(function (dt, i) { dt.classList.toggle('swiper-pagination-bullet-active', i === st.idx); dt.setAttribute('aria-selected', String(i === st.idx)); });
    if (els.prev) els.prev.disabled = st.idx <= 0;
    if (els.next) els.next.disabled = st.idx >= st.n - 1;
  }
  function go(i) {
    i = Math.max(0, Math.min(st.n - 1, i));
    try { els.track.scrollTo({ left: i * els.track.clientWidth, behavior: reduceMotion ? 'auto' : 'smooth' }); } catch (e) { els.track.scrollLeft = i * els.track.clientWidth; }
  }

  /* ---------- open / close ---------- */
  function open(o) {
    if (!root || !o || !o.handle) return;
    var handle = o.handle, inline = inlineData(handle);
    st.handle = handle; st.trigger = o.trigger || null; st.lastFocus = document.activeElement; st.source = o.source || document; st.qty = 1;
    var resolveFn = typeof cfg.resolve === 'function' ? cfg.resolve : defaultResolve; var res = resolveFn(st.trigger); st.select = !!(res && res.select);
    st.d = baseData(inline, handle); applySourceFacts(st.d, st.source);
    st.swatchBg = collectSwatches(st.source);
    st.rating = o.rating || findRating(st.source, st.d);
    st.v = pickVariant(st.d, o.variantId, o.variantTitle);
    st.open = true;
    clearAdded();
    render();
    root.removeAttribute('hidden');
    lockScroll();
    document.addEventListener('keydown', onKeys);
    watchDrawer();
    if (els.box) { try { els.box.focus({ preventScroll: true }); } catch (e) { els.box.focus(); } }
    if (typeof cfg.onOpen === 'function') cfg.onOpen({ handle: handle, variant: st.v, trigger: st.trigger });
    fetchProduct(handle).then(function (p) {
      if (!st.open || st.handle !== handle) return;
      st.d.media = p.media;
      if (!st.d.title) st.d.title = p.title;
      if (!st.d.variants.length) { st.d.variants = p.variants; st.d.expand = p.variants.length > 1; applySourceFacts(st.d, st.source); st.v = pickVariant(st.d, o.variantId, o.variantTitle); }
      else st.d.variants.forEach(function (v) { if (!v.media) { var pv = p.variants.filter(function (x) { return x.id === v.id; })[0]; if (pv) v.media = pv.media; } });
      render();
      sync();
    }).catch(function (err) {
      console.warn('[pz-qv] product media', handle, err);
      if (st.open && st.handle === handle) { st.d.media = []; render(); }
    });
  }
  function close(reason) {
    if (!st.open) return;
    st.open = false;
    qa('video', els.track).forEach(function (vd) { try { vd.pause(); } catch (e) { /* no-op */ } });
    root.setAttribute('hidden', '');
    els.track.innerHTML = ''; els.dots.innerHTML = '';
    unlockScroll();
    document.removeEventListener('keydown', onKeys);
    clearAdded();
    var back = st.trigger && st.trigger.isConnected ? st.trigger : st.lastFocus;
    if (back && back.focus && reason !== 'drawer') { try { back.focus({ preventScroll: true }); } catch (e) { back.focus(); } }
    if (typeof cfg.onClose === 'function') cfg.onClose({ reason: reason || 'user', handle: st.handle });
  }
  function select(id) {
    var v = pickVariant(st.d, id); if (!v || v === st.v) return;
    st.v = v; st.qty = 1;
    clearAdded();
    render();
  }
  function onKeys(e) {
    if (e.key === 'Escape') { e.preventDefault(); close('escape'); return; }
    if ((e.key === 'ArrowLeft' || e.key === 'ArrowRight') && root.contains(document.activeElement) && !document.activeElement.closest('[data-pz-qv-swatches]')) { e.preventDefault(); go(st.idx + (e.key === 'ArrowLeft' ? -1 : 1)); return; }
    if (e.key !== 'Tab') return;
    var f = qa('button:not([disabled]), a[href], input:not([type="hidden"]), [tabindex]:not([tabindex="-1"])', root).filter(function (el) { return el.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && (document.activeElement === first || !root.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && (document.activeElement === last || !root.contains(document.activeElement))) { e.preventDefault(); first.focus(); }
  }

  /* ---------- add ---------- */
  function showAdded() {
    var btn = els.add; if (!btn) return;
    var savedPrice = els.btnPrice.textContent;
    btn.classList.add('is-added');
    els.label.textContent = upper(cfg.labels.added); els.btnPrice.textContent = '';
    clearTimeout(st.addedT);
    st.addedT = setTimeout(function () { btn.classList.remove('is-added'); els.btnPrice.textContent = savedPrice; updateBtn(); }, cfg.addedMs);
  }
  function clearAdded() { clearTimeout(st.addedT); if (els.add) els.add.classList.remove('is-added'); }
  function onAddClick(e) {
    if (cfg.mode === 'bundle') {
      e.preventDefault();
      if (!st.v || !st.v.available || typeof cfg.add !== 'function') return;
      cfg.add(st.v, st.qty, els.add, updateBtn);
      return;
    }
    /* cart mode: the submit button submits the theme <product-form>; just make sure the form carries the shade + qty */
    if (els.formId) els.formId.value = st.v ? st.v.id : '';
    if (els.formQty) els.formQty.value = st.qty;
    if (!st.v || !st.v.available) e.preventDefault();
  }
  /* cart mode: the theme toggles .m-spinner-loading on <product-form>; when it ends without error → "ADDED" */
  function watchForm() {
    if (!els.pf || !('MutationObserver' in window)) return;
    var was = false;
    new MutationObserver(function () {
      var now = els.pf.classList.contains('m-spinner-loading');
      if (was && !now && st.open && !els.pf.error) showAdded();
      was = now;
    }).observe(els.pf, { attributes: true, attributeFilter: ['class'] });
  }
  /* the cart drawer (z 100) would sit behind the dialog: close on open */
  function watchDrawer() {
    if (drawerWatched || !cfg.closeOnDrawer) return;
    var dr = document.querySelector('m-cart-drawer'); if (!dr) return;
    drawerWatched = true;
    var onOpen = function () { if (st.open && dr.classList.contains('m-cart-drawer--active')) close('drawer'); };
    if ('MutationObserver' in window) new MutationObserver(onOpen).observe(dr, { attributes: true, attributeFilter: ['class'] });
    try { if (window.MinimogEvents && window.MinimogTheme && window.MinimogTheme.pubSubEvents) window.MinimogEvents.subscribe(window.MinimogTheme.pubSubEvents.openCartDrawer, function () { setTimeout(function () { if (st.open) close('drawer'); }, 0); }); } catch (e) { /* no-op */ }
  }

  /* ---------- wiring ---------- */
  function variantFromTrigger(t) {
    var id = t.getAttribute('data-pz-qv-variant');
    if (id) return id;
    var card = t.closest('[data-pz-card], .m-product-card, [data-pz-qv-scope]');
    var input = card && card.querySelector('input[name="id"]');
    return input ? input.value : '';
  }
  function sourceFromTrigger(t) {
    return t.closest('[data-pz-qv-scope]') || t.closest('[data-pz-card]') || t.closest('.m-product-card') || t.closest('.product-bundle-item') || t.closest('.product-shade-tab-wrapper') || document;
  }
  function init() {
    root = document.querySelector('[data-pz-qv-root]');
    if (!root) return;
    cfg.mode = root.getAttribute('data-pz-qv-mode') || cfg.mode;
    els = {
      box: q('[data-pz-qv-box]'), head: q('[data-pz-qv-head]'), track: q('[data-pz-qv-track]'), dots: q('[data-pz-qv-dots]'),
      prev: q('[data-pz-qv-prev]'), next: q('[data-pz-qv-next]'), title: q('[data-pz-qv-title]'), rating: q('[data-pz-qv-rating]'),
      price: q('[data-pz-qv-price]'), desc: q('[data-pz-qv-desc]'), swatches: q('[data-pz-qv-swatches]'), qty: q('[data-pz-qv-qty]'),
      add: q('[data-pz-qv-add]'), label: q('[data-pz-qv-label]'), btnPrice: q('[data-pz-qv-btn-price]'), selectBtn: q('[data-pz-qv-select]'),
      pf: q('[data-pz-qv-pf]'), formId: q('[data-pz-qv-form-id]'), formQty: q('[data-pz-qv-form-qty]')
    };
    root.addEventListener('click', function (e) {
      var t = e.target, btn;
      if (t.closest('[data-pz-qv-close]') || t.closest('[data-pz-qv-backdrop]')) { close('user'); return; }
      if ((btn = t.closest('[data-pz-qv-variant]'))) { select(btn.getAttribute('data-pz-qv-variant')); return; }
      if ((btn = t.closest('[data-pz-qv-step]'))) { st.qty = Math.max(1, Math.min(cfg.maxQty, st.qty + Number(btn.getAttribute('data-pz-qv-step')))); updateBtn(); return; }
      if (t.closest('[data-pz-qv-add]')) { onAddClick(e); return; }
      if (t.closest('[data-pz-qv-select]')) { e.preventDefault(); if (st.v && st.v.available) (typeof cfg.select === 'function' ? cfg.select : defaultSelect)(st.v, st); return; }
      if (t.closest('[data-pz-qv-prev]')) { go(st.idx - 1); return; }
      if (t.closest('[data-pz-qv-next]')) { go(st.idx + 1); return; }
      if ((btn = t.closest('[data-pz-qv-go]'))) { go(Number(btn.getAttribute('data-pz-qv-go'))); return; }
    });
    var scrollT = null;
    els.track.addEventListener('scroll', function () { clearTimeout(scrollT); scrollT = setTimeout(sync, 80); }, { passive: true });
    (function () {
      var y0 = null;
      els.head.addEventListener('touchstart', function (e) { y0 = e.touches[0].clientY; }, { passive: true });
      els.head.addEventListener('touchmove', function (e) { if (y0 != null && e.touches[0].clientY - y0 > 80) { y0 = null; close('swipe'); } }, { passive: true });
      els.head.addEventListener('touchend', function () { y0 = null; });
    })();
    window.addEventListener('resize', debounce(function () { if (st.open) { els.track.scrollLeft = st.idx * els.track.clientWidth; updateBtn(); } }, 150));
    watchForm();
    /* triggers (capture phase so data-pz-qv-stop can swallow a tile's own handlers) */
    document.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('[data-pz-qv-open]');
      if (!t || !root) return;
      if (t.hasAttribute('data-pz-qv-tile') && typeof cfg.tileOpens === 'function' && !cfg.tileOpens(t)) return; // the page handles this tile tap
      if (t.hasAttribute('data-pz-qv-stop')) { e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation(); }
      var vt = (typeof cfg.variantTitleFor === 'function' ? cfg.variantTitleFor : defaultVariantTitleFor)(t);
      open({ handle: t.getAttribute('data-pz-qv-open'), variantId: vt ? '' : variantFromTrigger(t), variantTitle: vt, source: sourceFromTrigger(t), trigger: t });
    }, true);
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
      var t = e.target.closest && e.target.closest('[data-pz-qv-open]');
      if (!t || t.tagName === 'BUTTON' || t.tagName === 'A' || t.querySelector('button:focus, a:focus')) return;
      if (t.hasAttribute('data-pz-qv-tile') && typeof cfg.tileOpens === 'function' && !cfg.tileOpens(t)) return;
      e.preventDefault(); t.click();
    });
  }
  function configure(o) {
    Object.keys(o || {}).forEach(function (k) { if (k === 'labels') { Object.keys(o.labels).forEach(function (l) { cfg.labels[l] = o.labels[l]; }); } else cfg[k] = o[k]; });
    if (root && o && o.mode) root.setAttribute('data-pz-qv-mode', o.mode);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  window.PZQuickView = { open: open, close: close, configure: configure, isOpen: function () { return st.open; }, state: st };
})();
